import * as React from 'react';
import {FormattedMessage, injectIntl} from '@meiko/react-intl';
import Panel from './Panel';
import PanelRow from './PanelRow';
import {fullAddress} from 'utils/buildings';
import {type as buildingType} from 'dicts/buildings';
import {getMessageIdForProductState} from 'utils/lists';

function BuildingPanel({building, lead, buildingProductStates = [], intl}) {
	const leadHasAddress = typeof lead?.address === 'string' && lead.address.length > 0;

	const mergedBuilding = {
		...(lead && leadHasAddress
			? {
					address: lead.address,
					city: lead.city,
					zip: lead.zip,
					manufacturingYear: null,
					type: '',
			  }
			: {}),
		...(building ? building : {}),
	};
	if (!mergedBuilding) {
		return null;
	}
	return (
		<Panel title={<FormattedMessage id="Building information" />}>
			<div className="overflow-x-auto  rounded flex flex-col">
				<PanelRow
					label={<FormattedMessage id="Address" />}
					value={fullAddress(mergedBuilding)}
				/>
				<PanelRow
					label={<FormattedMessage id="Building type" />}
					value={
						mergedBuilding.type ? (
							<FormattedMessage id={buildingType[mergedBuilding.type]} />
						) : (
							'-'
						)
					}
				/>
				<PanelRow
					label={<FormattedMessage id="Manufacturing year" />}
					value={building?.manufacturingYear ?? <FormattedMessage id="Not known" />}
				/>
				{Array.isArray(buildingProductStates) && buildingProductStates.length > 0 && (
					<PanelRow
						label={<FormattedMessage id="Products" />}
						value={
							<div className="flex flex-col gap-1">
								{buildingProductStates.map(p => (
									<div key={p.id}>
										{`${p.product?.data?.title} - ${intl.formatMessage({
											id: getMessageIdForProductState(p.encounterState),
										})} `}
										({intl.formatDate(p.encounterDate)})
									</div>
								))}
							</div>
						}
					/>
				)}
			</div>
		</Panel>
	);
}

export default injectIntl(BuildingPanel);
